import React from 'react'
import { Routes, Route } from "react-router-dom";
import Home from '../screens/Home/Home';

export default function MainContainer() {
  return (
    <Routes>
    <Route path="/" element={<Home />} />
    </Routes>
  )
}